import { coppockLookback } from '../../math/lookback'
import { COLOR, histogram, period } from '../../specs'
import type { IndicatorDef } from '../../types'

const def: IndicatorDef = {
  id: 'COPPOCK',
  version: 1,
  label: 'Coppock Curve',
  pane: 'sub',
  category: 'momentum',
  series: 'normal',
  precision: 2,
  order: 300,
  // TA-Lib's ROC accepts a period of 1; the WMA needs 2.
  inputs: [period('timeperiod', 10, 'WMA length'), period('timeperiod1', 14, 'Long ROC length', 1), period('timeperiod2', 11, 'Short ROC length', 1)],
  outputs: [histogram('coppock', 'Coppock', COLOR.green, COLOR.red)],
  talib: {
    functions: ['WMA', 'ROC'],
    expr: 'WMA(ROC(close, timeperiod={timeperiod1}) + ROC(close, timeperiod={timeperiod2}), timeperiod={timeperiod})',
  },
  listed: true,
  tailSafe: true,
  lookback: ({ timeperiod, timeperiod1, timeperiod2 }) => coppockLookback(timeperiod, timeperiod1, timeperiod2),
}
export default def
